// extracted by mini-css-extract-plugin
export default {"resource":"l-","title":"m-","items":"n-","resource_item":"o-","text":"p-","button":"q-"};
    if(module.hot) {
      // 1714654898606
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  